import { Logo } from '../components/Logo'
import { Aco } from '../components/Aco';
import {
  PageContainer,
  HeroSection,
  HeroContent,
  BackLink,
  ContentSection,
  Container,
  MainContent,
  SideContent,
  ProductTitle,
  ProductSubtitle,
  SectionTitle,
  SubSectionTitle,
  Paragraph,
  InfoTable,
  TableRow,
  TableDataLabel,
  TableData,
  NumberData,
  List,
  AcoContainer,
  DecorativeElement
} from './ProductStyles';

const data = [
  {en: "Prenyl acetate", ja: "プレニルアセテート", value: "0.36%"},
  {en: "Alpha-pinene", ja: "アルファ-ピネン", value: "0.28%"},
  {en: "Beta-pinene", ja: "ベータ-ピネン", value: "0.1%"},
  {en: "Myrcene", ja: "ミルセン", value: "0.17%"},
  {en: "p-methyl anisole", ja: "p-メチルアニソール", value: "6.81%"},
  {en: "limonene", ja: "リモネン", value: "0.05%"},
  {en: "1,8-cineole", ja: "1,8-シネオール", value: "0.43%"},
  {en: "Mythyl benzoate", ja: "メチルベンゾエート", value: "3.25%"},
  {en: "Linalool", ja: "リナロール", value: "13.96%"},
  {en: "Benzyl acetate", ja: "ベンジルアセテート", value: "3.12%"},
  {en: "Alpha-terpineol", ja: "アルファ-テルピネオール", value: "0.17%"},
  {en: "Geraniol", ja: "ゲラニオール", value: "2.12%"},
  {en: "Geranial", ja: "ゲラニアール", value: "0.09%"},
  {en: "Neryl acetate", ja: "ネリルアセテート", value: "0.79%"},
  {en: "Alpha-copaene", ja: "アルファ-コパエン", value: "0.86%"},
  {en: "Geranyl acetate", ja: "ゲラニルアセテート", value: "9.95%"},
  {en: "Beta-elemene", ja: "ベータ-エレメン", value: "0.49%"},
  {en: "Beta-caryophyllene", ja: "ベータ-カリオフィレン", value: "12.7%"},
  {en: "Trans-cinnamyl acetate", ja: "トランス-シンナミルアセテート", value: "0.65%"},
  {en: "Alpha-humulene", ja: "アルファ-ヒュムレン", value: "4.1%"},
  {en: "Gamma-muurolene", ja: "ガンマ-ムウロレン", value: "1.42%"},
  {en: "Germacrene D", ja: "ジャーマクレンD", value: "8.82%"},
  {en: "Cis-gamma-bisabolene", ja: "シス-ガンマ-ビサボレン", value: "1.82%"},
  {en: "(E,E)-alpha-farnesene", ja: "(E,E)-アルファ-ファルネセン", value: "5.83%"},
  {en: "Gamma-cadinene", ja: "ガンマ-カジネン", value: "0.8%"},
  {en: "Delta-cadinene", ja: "デルタ-カジネン", value: "2.98%"},
  {en: "Epi-alpha-cadinol", ja: "エピ-アルファ-カジノール", value: "1.12%"},
  {en: "Alpha-cadinol", ja: "アルファ-カジノール", value: "1.49%"},
  {en: "(E,E)—farnesol", ja: "(E,E)-ファルネソール", value: "1.36%"},
  {en: "Benzyl benzoate", ja: "ベンジルベンゾエート", value: "5.43%"},
  {en: "(E,E)-farnesyl acetate", ja: "(E,E)-ファルネシルアセテート", value: "1.05%"},
  {en: "Benzyl salicylate", ja: "ベンジルサリシレート", value: "1.17%"},
]

export const YlangYlang11 = () => (
  <PageContainer>
    <HeroSection>
      <BackLink to="/">ホームに戻る</BackLink>
      <HeroContent>
        <Logo />
      </HeroContent>
    </HeroSection>
    
    <ContentSection>
      <Container>
        <MainContent>
          <DecorativeElement className="top-right" />
          <DecorativeElement className="bottom-left" />
          
          <ProductTitle>イランイラン (ロット11)</ProductTitle>
          <ProductSubtitle>Cananga odorata</ProductSubtitle>
          
          <SectionTitle>使用期限</SectionTitle>
          <Paragraph>{new Date('2027-06-30T00:00:00.000+09:00').toLocaleDateString()}</Paragraph>
          
          <SectionTitle>製品の特徴</SectionTitle>
          <InfoTable>
            <tbody>
              <TableRow>
                <TableDataLabel>原産国</TableDataLabel>
                <TableData>マダガスカル</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出部位</TableDataLabel>
                <TableData>花</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出方法</TableDataLabel>
                <TableData>水蒸気蒸留法</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>学名</TableDataLabel>
                <TableData>Cananga odorata</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>科名</TableDataLabel>
                <TableData>バンレイシ科</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>効果</TableDataLabel>
                <TableData>リラックス効果、ストレス軽減、気分の向上</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>ロット番号</TableDataLabel>
                <TableData>11</TableData>
              </TableRow>
            </tbody>
          </InfoTable>
          
          <SectionTitle>分析証明書</SectionTitle>
          
          <SubSectionTitle>製品識別と組成</SubSectionTitle>
          <List>
            <li>製品名: Ylang Ylang 1st Oil 100% Organic ACO (ロット11)</li>
            <li>学名: Cananga odorata</li>
            <li>ロット番号: 11</li>
          </List>
          
          <SubSectionTitle>物理的および化学的特性</SubSectionTitle>
          <List>
            <li>外観: 透明、淡黄色から黄色琥珀色の液体</li>
            <li>香り: 特徴的、非常に甘く、豊かで、わずかにスパイシー、バルサミックフローラル、リッチでクリーミーな背景とジャスミンのような上音</li>
            <li>比重: 0.9200 から 0.97500 @ 20°C</li>
            <li>屈折率: 1.4900 から 1.5200 @ 20°C</li>
          </List>
          
          <SubSectionTitle>ガスクロマトグラフ分析結果</SubSectionTitle>
          <InfoTable>
            <tbody>
              {data.map((item, index) => (
                <TableRow key={index}>
                  <TableDataLabel>{item.ja}</TableDataLabel>
                  <NumberData>{item.value}</NumberData>
                </TableRow>
              ))}
            </tbody>
          </InfoTable>
        </MainContent>
        
        <SideContent>
          <AcoContainer>
            <Aco />
          </AcoContainer>
        </SideContent>
      </Container>
    </ContentSection>
  </PageContainer>
);
